
<script>
  import { getContext } from 'svelte';
  import { hash } from '../../apps/imd/stores';

  /** @type {import('~/apps/imd').default} */
  const app = getContext('app');
  const uri = `/${$hash}/imdlogo/${app.setting('serverStartTime')}`;
</script>

<div class="header-logo">
  <img class="header-logo__img" src="{uri}" alt="Venue logo"/>
</div>
